import React from 'react'

function PageNotFound() {
  return (
    <div>
      <center><h1>Page Not Found!!</h1></center>
    </div>
  )
}

export default PageNotFound
